Controller.$inject = ['$transclude', '$timeout'];

function Controller($transclude, $timeout) {
    const self = this;
    self.hasDescription = false;

    self.handleChange = () => {
        $timeout(() => {
            self.onChange()
        });
    }

    self.$postLink = () => {
        self.hasDescription = $transclude.isSlotFilled('description');
    }
}

export function HuiInputSwitch() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            ngModel: '=',
            labelPosition: '@',
            disabled: '<',
            onChange : '&'
        },
        controller: Controller,
        controllerAs: '$inputSwitchCtrl',
        transclude: {
            description: '?huiInputDescription'
        },
        template: ($element, $attrs) => {
            return `
            <div class="hui hui-input hui-input-switch-container"
                 role="switch"
                 aria-checked="{{$inputSwitchCtrl.ngModel}}"
                 tabindex="0"
                 aria-labelledby="switch-input"
                 ng-class="{'off-disabled': $inputSwitchCtrl.disabled && !$inputSwitchCtrl.ngModel,
                            'on-disabled': $inputSwitchCtrl.disabled && !!$inputSwitchCtrl.ngModel,
                            'start': $inputSwitchCtrl.labelPosition === 'start',
                            'with-description': !!$inputSwitchCtrl.hasDescription}">
                <label class="hui-switch" 
                ng-class="{'toggle-checked': $inputSwitchCtrl.ngModel}">
                  <input ng-model="$inputSwitchCtrl.ngModel" 
                         ng-change="$inputSwitchCtrl.handleChange()"
                         ng-disabled="$inputSwitchCtrl.disabled"
                         class="hui-input-switch"
                         type="checkbox">
                   <span class="hui-switch-toggle"></span>
                </label>
                
                <div>
                    <div ng-transclude></div>
                    <div class="input-description" ng-transclude ng-transclude-slot="description"></div>
                </div>
            </div>
          `;
        }
    }
}